import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../config/supabase';
import { useNavigate } from 'react-router-dom';

const ConceptKeyword = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      if (!user) {
        navigate('/vip');
        return;
      }

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .single();

        if (error) {
          navigate('/vip');
          return;
        }

        if (!data) {
          navigate('/vip');
          return;
        }

        const allowedMemberships = ['vip', 'admin', 'lifetime'];
        if (!allowedMemberships.includes(data.membership?.toLowerCase()) && !(data.membership === 'free' && data.has_purchased_vip === true)) {
          navigate('/vip');
          return;
        }

        setProfile(data);

      } catch (error) {
        navigate('/vip');
      }
    };

    checkAuth();
  }, [user, navigate]);

  // แสดง loading ระหว่างตรวจสอบสิทธิ์
  if (!profile) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Helmet>
        <title>คลังคีย์เวิร์ด - AI Unlocked</title>
      </Helmet>

      <main className="flex-grow container mx-auto px-4 py-12">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-4">คลังคีย์เวิร์ด</h1>
          <p className="text-gray-400 text-xl mb-8">
            Google Sheet สำหรับหัวข้อ และคีย์ที่แตกแล้ว ที่ผมใช้อยู่ปัจจุบันนะครับ  แชร์ให้ดู หรือใครจะเอาไปเจนก็ได้ครับ เพราะมันเป็นคีย์ ไม่ได้เป็นพร้อมยาวๆ
          </p>
          
          <a 
            href="https://docs.google.com/spreadsheets/d/1ItxCP5sCY2PL0G7cGui2Pih0M6BTgsSj3Py4MBU1994/edit?gid=500022439#gid=500022439"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-green-600 hover:bg-green-700 text-white text-xl px-8 py-4 rounded-lg transition-colors mb-8"
          >
            เข้าดู คลังคีย์เวิร์ด
          </a>

          <div className="max-w-2xl mx-auto mb-8">
            <h2 className="text-2xl font-bold mb-4">วิธีใช้งาน</h2>
            <ul className="text-left text-lg space-y-3 text-gray-300">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                เลือกหมวด ไปใส่ gpt ต่างๆที่ต้องการเพื่อหาคีย์ มาทำ prompt
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                เลือกคีย์ต่างๆไป ใส่ <a href="https://www.aiunlockedvip.com/vipgen" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">https://www.aiunlockedvip.com/vipgen</a> เพื่อสร้าง prompt ได้เลย
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                เลือกคีย์ ต่างๆ ไปสร้าง prompt ด้วย Ready Prompt 2.0
              </li>
            </ul>
          </div>

          <div className="mt-8">
            <img 
              src="/images/keyworddDB.png" 
              alt="คลังคีย์เวิร์ด"
              className="max-w-full h-auto mx-auto"
            />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ConceptKeyword;
